<div
  class="header h-[55px] flex justify-between items-center p-[50px] !bg-[#DEE2E6] sticky z-50 top-0"
>
  <div class="flex items-center">
    <p class="!m-0">{{labels.title}}</p>
    <p
      class="!mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px]"
    >
      Conclusions
    </p>
  </div>
  <div>
    <mat-icon class="cursor-pointer" (click)="closeModalEvent.emit()"
      >close</mat-icon
    >
  </div>
</div>

<form [formGroup]="form">
  <p class="subBrief pl-[46px] pb-[23px] !mt-[30px]">
    We welcome your participation in this tender process and look forward to
    receiving your proposal. Should you require any further information or
    Clarification (NEW SYSTEM REQUIRED),<br />
    please do not hesitate to contact us as indicated in Section 4.  Yours
    sincerely,
  </p>

  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Your Name</mat-label>
          <input
            matInput
            type="text"
            formControlName="your_name_control"
            placeholder="Your Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('your_name_control').invalid &&
            form.get('your_name_control').touched
          "
          class=""
        >
          <span style="color: red">Your name is required</span>
        </div>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Your Position </mat-label>
          <input
            matInput
            type="text"
            formControlName="your_position_control"
            placeholder="Your Position"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('your_position_control').invalid &&
            form.get('your_position_control').touched
          "
          class=""
        >
          <span style="color: red">Your position is required</span>
        </div>
      </div>
    </div>
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Company Name </mat-label>
          <input
            matInput
            type="text"
            formControlName="company_name_control"
            placeholder="Company Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('company_name_control').invalid &&
            form.get('company_name_control').touched
          "
          class=""
        >
          <span style="color: red">Company name is required</span>
        </div>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Contact Information </mat-label>
          <input
            matInput
            type="text"
            formControlName="contact_information_control"
            placeholder="Contact Information "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('contact_information_control').invalid &&
            form.get('contact_information_control').touched
          "
          class=""
        >
          <span style="color: red">Contact information is required</span>
        </div>
      </div>
    </div>
  </div>

  <p class="disclaimer pl-[47px] pt-[23px]">Disclaimer</p>
  <p class="subBrief pl-[46px]">The Client reserves the right to:</p>
  <ul class="subBrief pl-[68px]">
    <li>Amend or withdraw this {{labels.title}} at any stage without liability. </li>
    <li>Reject any or all tenders without giving reasons. </li>
    <li>
      Award the contract in part or not at all, depending on the Client’s best
      interests. 
    </li>
    <li>
      Disqualify any tenderer found to have engaged in corrupt or fraudulent
      practices. 
    </li>
  </ul>
  <div
    class="!pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="moveToPreviousStep()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Finish
      </button>
    </div>
  </div>
</form>
